import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import Modal from "../common/Modal";
import UserIcon from "../common/UserIcon";
import Store from "../../utils/Store";
import { useStoreState } from "pullstate";
import { useContext, useEffect, useState } from "react";
import { getTrimmedWorkspaceId } from "../../utils";
import updateWorkspaceReferral from "./services/updateWorkspaceReferral";
import Toast from "../Toast";
import { t } from "i18next";
import { PatientsContext } from "../Patients/PatientsContext";
var AudibleNotifications = function AudibleNotifications() {
  var _useState = useState([]),
    pendingReferrals = _useState[0],
    setPendingReferrals = _useState[1];
  var _useState2 = useState(0),
    currentIndex = _useState2[0],
    setCurrentIndex = _useState2[1];
  var _useState3 = useState(false),
    loadingStates = _useState3[0],
    setLoadingStates = _useState3[1];
  var _useContext = useContext(PatientsContext),
    pendingReferral = _useContext.pendingReferral;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        workspaceAudibleNotifications: s.workspaceAudibleNotifications
      };
    }),
    workspaceAudibleNotifications = _useStoreState.workspaceAudibleNotifications;
  useEffect(function () {
    if (pendingReferral) {
      setPendingReferrals(pendingReferral === null || pendingReferral === void 0 ? void 0 : pendingReferral.filter(function (ws) {
        return ws.status === 0;
      }));
      setCurrentIndex(0);
      Store.update(function (s) {
        s.workspaceAudibleNotifications = true;
      });
    }
  }, [pendingReferral]);
  var handleAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(action) {
      var currentReferral, updatedReferrals, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            currentReferral = pendingReferrals[currentIndex];
            if (currentReferral) {
              _context.n = 1;
              break;
            }
            Toast.error(t("no_current_referral_found"));
            return _context.a(2);
          case 1:
            setLoadingStates(true);
            _context.p = 2;
            _context.n = 3;
            return updateWorkspaceReferral(currentReferral.workspace_id, {
              referral_id: currentReferral.referral_id,
              status: action === "approve" ? 2 : action === "reject" ? 3 : 1
            });
          case 3:
            // Remove the processed referral from the list
            updatedReferrals = pendingReferrals.filter(function (_, index) {
              return index !== currentIndex;
            });
            setPendingReferrals(updatedReferrals);

            // Check if there are more referrals to process
            if (updatedReferrals.length > 0) {
              // If we were at the last item, go to the new last item
              if (currentIndex >= updatedReferrals.length) {
                setCurrentIndex(updatedReferrals.length - 1);
              }
              // If we were not at the last item, stay at the same index
              // (since the item at currentIndex was removed, the next item is now at currentIndex)
            } else {
              // All referrals processed, close modal
              Store.update(function (s) {
                s.workspaceAudibleNotifications = false;
              });
              setCurrentIndex(0);
            }
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            Toast.error(t("something_went_wrong"));
          case 5:
            _context.p = 5;
            setLoadingStates(false);
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4, 5, 6]]);
    }));
    return function handleAction(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleDecideLater = function handleDecideLater() {
    if (!loadingStates) {
      handleAction("decide_later");
    }
  };
  var handleApprove = function handleApprove() {
    if (!loadingStates) {
      handleAction("approve");
    }
  };
  var handleReject = function handleReject() {
    if (!loadingStates) {
      handleAction("reject");
    }
  };
  var currentReferral = pendingReferrals[currentIndex];
  if (!currentReferral) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    closeOnClickAway: !loadingStates,
    show: workspaceAudibleNotifications,
    className: "w-full max-w-sm !rounded-xl overflow-hidden !text-left mb-8 !bg-gray-900 dark:!bg-gray-100 !text-gray-900 border border-gray-700 dark:border-gray-300"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center px-5 py-4 text-gray-100 dark:text-gray-900 bg-gray-800 dark:bg-gray-200 border-b border-gray-700 dark:border-gray-300"
  }, /*#__PURE__*/React.createElement("p", null, pendingReferrals === null || pendingReferrals === void 0 ? void 0 : pendingReferrals.length, " ", t("new_workspace_request"), (pendingReferrals === null || pendingReferrals === void 0 ? void 0 : pendingReferrals.length) > 1 ? "s" : ""), /*#__PURE__*/React.createElement("p", null, currentIndex + 1, "/", pendingReferrals === null || pendingReferrals === void 0 ? void 0 : pendingReferrals.length)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-5 border-b border-gray-700 dark:border-gray-300"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-medium text-gray-100 dark:text-gray-800"
  }, currentReferral.workspace_name), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-300 dark:text-gray-700 text-md"
  }, "#", getTrimmedWorkspaceId(currentReferral === null || currentReferral === void 0 ? void 0 : currentReferral.source_uuid))), /*#__PURE__*/React.createElement("div", {
    className: "p-5 space-y-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-4 items-center"
  }, /*#__PURE__*/React.createElement(UserIcon, {
    name: currentReferral.requester_name,
    className: "!bg-gray-800 dark:!bg-gray-200 !text-gray-200 dark:!text-gray-800 p-3 !rounded-full !w-[40px] !h-[40px] font-medium"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-200 dark:text-gray-800 font-medium"
  }, currentReferral.requester_email), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-600 text-md"
  }, t("requesting_access_to_workspace")))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between font-medium space-x-4"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: loadingStates,
    className: "text-teal-400 dark:text-teal-500 hover:text-teal-600 transition-colors outline-none ".concat(loadingStates ? "opacity-50 cursor-not-allowed" : ""),
    onClick: handleDecideLater
  }, t("button.decide_later")), /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-4 items-center"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: loadingStates,
    onClick: handleReject,
    className: "p-5 bg-red-600 text-gray-100 rounded-lg hover:bg-red-700 transition-colors ".concat(loadingStates ? "opacity-50 cursor-not-allowed" : "")
  }, t("button.reject")), /*#__PURE__*/React.createElement("button", {
    disabled: loadingStates,
    onClick: handleApprove,
    className: "p-5 bg-green-600 text-gray-100 rounded-lg hover:bg-green-700 transition-colors ".concat(loadingStates ? "opacity-50 cursor-not-allowed" : "")
  }, t("button.approve")))))));
};
export default AudibleNotifications;